module.exports = __webpack_public_path__ + "static/media/webshop_splash_accessories.650cbe23.png";